
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
window.scrollAnimation = new(function() {
    this.scroller = false;
    this.init = function(){

        gsap.registerPlugin(ScrollTrigger);
        const content = document.getElementById('global')
       
        // Using Locomotive Scroll from Locomotive https://github.com/locomotivemtl/locomotive-scroll
        // each time Locomotive Scroll updates, tell ScrollTrigger to update too (sync positioning)
       
          

          document.addEventListener('scroll',()=>{
              //ScrollTrigger.update()
              
              if (window.scrollY >  window.outerHeight / 2){
                $('body').addClass('show-burguer')
              }else{
                $('body').removeClass('show-burguer')
              }
        })


        
        // tell ScrollTrigger to use these proxy methods for the ".smooth-scroll" element since Locomotive Scroll is hijacking things
        /*ScrollTrigger.scrollerProxy("[data-scroll-container]", {
          scrollTop(value) {
            return arguments.length ? window.globalScroll.scrollTo(value, 0, 0) : window.globalScroll.offset;
          }, // we don't have to define a scrollLeft because we're only scrolling vertically.
          getBoundingClientRect() {
            return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
          },
          // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
          pinType: document.querySelector("[data-scroll-container]").style.transform ? "transform" : "fixed"
        });


        // each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll.*/
      


    }
    this.initGlobal = function(){
      if (ScrollTrigger.isScrolling()) {
        // do something if scrolling
        if (window.scene) window.scene.autoRender = false

      }else{
        if (window.scene) window.scene.autoRender = true

      }
      

    }
    this.trigger = []
    this.resetTrigger = function(){
        this.trigger.forEach(t => t.kill(true));

    }
    this.initView = function(){
      this.resetTrigger()
      let headerOpacity = gsap.timeline({paused:true})
      headerOpacity.fromTo('header .main-header__bg',{
        autoAlpha:0,
      },{
        autoAlpha:1
      })
      this.trigger.push(ScrollTrigger.create({
        trigger: 'section',
        start:'top top',
        end:window.outerHeight / 2,
        scrub:true,
        animation:headerOpacity,
        invalidateOnRefresh: false,
        
      }))
      gsap.utils.toArray("[data-barba-namespace]:last-of-type [data-scroll]").forEach((section, i) => {
        this.trigger.push(ScrollTrigger.create({
          trigger: section,
          once: true,
          scrub:false,
          invalidateOnRefresh: false,
          onEnter: () => {
              $(section).addClass('is-inview');
          },
          onEnterBack: () => {
            $(section).addClass('is-inview');
          }
        }))
      });
      // HEADER ANIMATION // 

      
      if ($('[data-barba-namespace]:last-of-type #home-header').length){
        let headerAnimations = gsap.timeline({paused:true})            
        headerAnimations.fromTo('[data-barba="container"]:last-of-type #home-header',{
            duration:1,
            //filter:'blur(0) grayscale(0)',
            autoAlpha: 1,

            ease:"none",
        },{
            duration:1,
            autoAlpha: 0,
            //filter:'blur(10px) grayscale(1)',
            ease:"none",
        },'animationHeader')
        
        
        this.trigger.push(ScrollTrigger.create({
          trigger: '[data-barba-namespace]:last-of-type #home-header',
          start:'top top',
          end: '+=100%',
          scrub:true,
          invalidateOnRefresh: true,
          animation:headerAnimations,
  
        }))
      }
      
      // TEXT //
      if (window.scene){
        gsap.utils.toArray("[data-barba-namespace]:last-of-type [data-dynamic-text]").forEach((section, i) => {

          console.log('GET ALL SECTION', section)
          let targetThree = window.scene.text.getText($(section).attr('data-uuid'));
          if (targetThree){
            let timelineText = gsap.timeline({paused:true})
            timelineText.to(targetThree.material.uniforms.uAlpha,{
              value:1,
              duration:2,
              ease:'power2.out',
           
              
            },'showText') 
            timelineText.to(targetThree.material.uniforms.mainColor.value,{
                x:1,
                y:1,
                z:1,
                duration:2,
                ease:'power2.out'
              },'showText') 
              timelineText.to(targetThree.material.uniforms.uNoiseStrength,{
                value:  4.0,
                duration:2,
                ease:'power2.out'
              },'showText') 
            
            timelineText.to(targetThree.material.uniforms.distDensity,{
                value:0,
                duration:2,
                ease:'power2.out'
            },'showText') 
            this.trigger.push(ScrollTrigger.create({
              trigger: section,
              once: true,
              start:'center center',
              animation:timelineText,
              invalidateOnRefresh: true,
             
          }))
          }
        
        });
      }
   
      // TUTU // 
      if ($('[data-barba-namespace]:last-of-type .describe').length ){
          let translateTitles = gsap.timeline({paused:true})
          translateTitles.from('[data-barba-namespace]:last-of-type .describe .card-wrapper:nth-child(1) .medium-title',{
          
            duration:1,
            xPercent: -100,
            z:.1,
            
            ease:"none",
          },'tanslateTitles')
          translateTitles.from('[data-barba-namespace]:last-of-type .describe .card-wrapper:nth-child(2) .medium-title',{
          
            duration:1,
            xPercent: 100,
            z:.1,

    
            ease:"none",
          },'tanslateTitles')
          if (window.scene){
            translateTitles.fromTo('.webgl-overlay',{
              duration:1,
              autoAlpha: 1,
              ease:"none",
            },{
              duration:1,
              autoAlpha: 0,
              ease:"none",
            },'tanslateTitles')
          }
          
         
          this.trigger.push(ScrollTrigger.create({
            trigger: '[data-barba-namespace]:last-of-type .describe',
            start:'top bottom',
            end: '+=50%',
            scrub:2,
            invalidateOnRefresh: true,
            animation:translateTitles,
    
          }))
      }
      // FOOTER // 
      if (window.scene){
        let lightAnimation = gsap.timeline({paused:true})
        lightAnimation.fromTo('.webgl-overlay',{
          duration:1,
          autoAlpha: 0,

          ease:"none",
        },{
          duration:1,
          autoAlpha: 1,
 
          ease:"none",
        },'smokeFadeIn')
      
        this.trigger.push(ScrollTrigger.create({
          trigger: 'footer',
          start:'top-=200% bottom',
          end: '+=100%',
          scrub:2,
          invalidateOnRefresh: true,
          animation:lightAnimation,

        }))
      }
      // STICKY BOX
      ScrollTrigger.create({
        trigger:'.sticky-sharing-container' ,
        scroller: this.scroller,
        pin:true,
        pinSpacing:false,
        anticipatePin:true,
        invalidateOnRefresh:false,
        start:'bottom bottom',
        end:'top bottom',
        endTrigger:'footer'
       
        
    });
      

      this.update()
    }

   
  

    this.lazyload = function() {
      gsap.utils.toArray("[data-barba-namespace]:last-of-type [data-scroll-call='lazyload']").forEach((section, i) => {
          console.log('SECTION LAZY',section)
          ScrollTrigger.create({
              trigger: section,
              start: "-50% bottom",
              once: true,

              onEnter: () => {
                  window.imageLoader.lazy(section);

               
              },
              onEnterBack: () => {
                window.imageLoader.lazy(section);

              }
          });
      });
  }


    this.update = function(){
        //ScrollTrigger.refresh(true);
        window.globalScroll.updateView();
    }
});
